export default __webpack_public_path__ + "static/media/8-10_icon.f391e5c9.svg";